<template>
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">최근 본 제품</h1>
    </div>

    <div class="l-content">
      <!-- D: 최근 본 제품 페이지 -->
      <div class="p-product-history-wrap">
        <div class="l-white-box">
          <div class="history-list-box">
            <div class="line-title-box">
              <div class="c-title-level3">
                <strong>총 : </strong>
                <b>{{ data.biz1.list.length }}개</b>
              </div>
              <!-- D: MO 전용 -->
              <div class="c-btn-area only-mo">
                <button
                  type="button"
                  class="c-util-button type-line-gray"
                  @click="btnCmd('deleteAll')"
                >
                  <span>전체삭제</span>
                </button>
              </div>
              <!-- // D: MO 전용 -->
            </div>
            <!-- D: PC 전용 -->
            <div class="c-order-control-box only-pc">
              <div class="left-box">
                <div class="c-checkbox type-small">
                  <input
                    type="checkbox"
                    id="all-recent-history-chk1-0"
                    name="recent-history-chk"
                    :checked="data.isAllCheck"
                    @click="btnCmd('selectAllCheck')"
                  />
                  <label for="all-recent-history-chk1-0">전체선택</label>
                </div>
                <button
                  type="button"
                  class="btn-selected-delete"
                  @click="btnCmd('deleteCheckList')"
                >
                  <i class="c-icon icon-check"></i>
                  <span>선택삭제</span>
                </button>
              </div>
              <!-- 2025-01-01 삭제 -->
            </div>
            <!-- // D: PC 전용 -->
            <div class="list">
              <div
                class="item"
                v-for="(item1, index1) in filteredList1(data.grp1name)"
                :key="index1"
              >
                <div class="title-box c-title-level3">
                  <strong>{{ item1.regDtInfo }}</strong>
                </div>
                <!-- D: PC 전용 -->
                <div class="scroll-x">
                  <div class="scroll-x-inner">
                    <div class="table-box only-pc" style="width: 1102px">
                      <div class="c-table">
                        <table>
                          <caption>
                            최근 본 제품 리스트 테이블
                          </caption>
                          <colgroup>
                            <col style="width: 500px" />
                            <col style="width: 120px" />
                            <col />
                            <col />
                            <!-- 2025-01-01 추가 -->
                            <col />
                          </colgroup>
                          <tbody>
                            <rcentlyViewedProdItemPc
                              v-for="(item2, index2) in filteredList2(
                                data.grp1name,
                                item1.regDtInfo
                              )"
                              :key="index2"
                              :product="item2"
                              @buy="(product) => btnCmd('buy', product)"
                              @cart="(product) => btnCmd('cart', product)"
                              @select="(product) => btnCmd('select', product)"
                              @delete="(product) => btnCmd('delete', product)"
                            />
                          </tbody>
                        </table>
                        <!-- <div
                          v-for="(item2, index2) in filteredList2(
                            data.grp1name,
                            item1.regDtInfo
                          )"
                          :key="index2"
                        >
                          {{ item2 }}
                          {{ index2 }}
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <!-- // D: PC 전용 -->

                <!-- D: MO 전용 -->
                <div class="c-products type-list only-mo">
                  <rcentlyViewedProdItemMo
                    class="c-product-card type-horizontal"
                    v-for="(item2, index2) in filteredList2(
                      data.grp1name,
                      item1.regDtInfo
                    )"
                    :key="index2"
                    :product="item2"
                    @buy="(product) => btnCmd('buy', product)"
                    @cart="(product) => btnCmd('cart', product)"
                    @select="(product) => btnCmd('select', product)"
                    @delete="(product) => btnCmd('delete', product)"
                  />
                </div>
                <!-- // D: MO 전용 -->
              </div>
            </div>
            <!-- 2025-01-01 버튼 삭제 -->
            <!-- D: NO DATA -->
            <div
              class="c-no-data-box"
              v-if="data.page.isPageInit && data.biz1.list.length < 1"
            >
              <div class="icon-box">
                <i class="c-icon icon-nodata size-large"></i>
              </div>
              <p class="text">최근 본 제품이 없습니다.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <QuickMenu />
  </div>
  <ProdInfoPop
    v-if="isShowProdInfoPop"
    v-bind="prodInfoPopProps"
    @close="() => (isShowProdInfoPop = false)"
  />
</template>

<script setup name="rcentlyViewedProd">
import { onMounted, reactive, defineEmits, watch, ref, provide } from "vue";

import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import rcentlyViewedProdItemPc from "@/components/paintpro/quickMenu/rcentlyViewedProdItemPc.vue";
import rcentlyViewedProdItemMo from "@/components/paintpro/quickMenu/rcentlyViewedProdItemMo.vue";
import ProdInfoPop from "@/components/paintpro/prod/prodInfoPop.vue";

import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil";
import * as orderApi from "@/api/orderApi.js";
import * as store from "@/store";
import { useRoute } from "vue-router";

const authStore = store.useAuthStore();
const route = useRoute();

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    isPageInit: false,
    token: "",
    isLogin: false,
    userLoginInfo: {},
    basketCount: {},
    breadcrumbItems: [
      { name: "zsample", path: "/paintpro/zsample" },
      { name: "zsample07", path: "/paintpro/zsample/zsample07" },
    ],
    path: "",
  },
  isAllCheck: false,
  grp1name: "all",
  codes: {},
  popup: {},
  biz1: {
    list: [], // 목록
  },
  selectedBranch: null,
  eventBus: {
    salesPersonIndex: 0,
  },
});

const isShowProdInfoPop = ref(false);
const prodInfoPopProps = ref({
  matnr: null,
});

/**********************
 * watch
 *********************/

// 헤더 영업사원 콤보박스
watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  (newValue) => {
    if (newValue >= 0 && data.page.userLoginInfo?.empList?.length > newValue) {
      data.selectedBranch = data.page.userLoginInfo.empList[newValue];
    }
  }
);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

// const emits = defineEmits(["selectChanged"]);
const emits = defineEmits(["close"]);

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();
  data.grp1name = "all";
  searchCmd("biz1#search"); // biz1 데이타 조회
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  const res = await cmApi.getPageInitData();
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: recentlyViewerdProd.pageInitData] `);
    return false;
  }
  data.page.path = route.path;
  data.page.userLoginInfo = authStore?.user;

  // 영업사원 디폴트
  data.eventBus.salesPersonIndex = store.useEventBusStore()?.salesPersonIndex;
  data.selectedBranch =
    data.page.userLoginInfo.empList[data.eventBus.salesPersonIndex];
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", parms = {}) {
  // ◼ biz1 [조회]
  if (cmd === "biz1#search") {
    data.biz1.list = [];
    data.biz1.loading = true;
    const res = await cmApi.selectUserRecentlyProdList();
    data.page.isPageInit = true;
    data.biz1.list = res.data;
  }
  // ◼ 기타
  else {
    alert(`[개발확인] searchCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

// 일자별 그룹명
function filteredList1(_grp1Nm = "") {
  let uniqItems = [];
  //const groupList =
  data.biz1.list.reduce((acc, item) => {
    const { ntalkTaskSeCd, regDtInfo } = item; // 그룹화 기준을 category로 설정
    if (["all", ntalkTaskSeCd].includes(_grp1Nm)) {
      const _groupName = _grp1Nm + "#" + regDtInfo; // 그룹기준
      if (!acc[_groupName]) {
        acc[_groupName] = []; // 그룹화된 객체가 없으면 새로 생성
        uniqItems.push(item);
      }
      acc[_groupName].push(item); // 해당 카테고리에 항목 추가
    }
    return acc;
  }, {});
  //return groupList;
  return uniqItems;
}

// // 그룹의 하위
function filteredList2(_grp1Nm = "", _grp2Nm = "") {
  let list = data.biz1.list.filter((item) => {
    const { ntalkTaskSeCd, regDtInfo } = item;
    return ["all", ntalkTaskSeCd].includes(_grp1Nm) && regDtInfo === _grp2Nm;
  });
  return list;
}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  // ◼ [닫기]
  if (cmd === "close") {
    emits("close");
  }
  // ◼ [전체선택]
  else if (cmd === "selectAllCheck") {
    data.isAllCheck = !data.isAllCheck;
    for (let i = 0; i < data.biz1.list.length; i++) {
      data.biz1.list[i].chk = data.isAllCheck;
    }
  }
  // ◼ [선택삭제]
  else if (cmd === "deleteCheckList") {
    let ids = [];
    // data.isAllCheck = !data.isAllCheck;
    for (let i = 0; i < data.biz1.list.length; i++) {
      if (data.biz1.list[i].chk) {
        ids.push(data.biz1.list[i].idntyPrdctSn);
      }
    }

    if (ids.length < 1) {
      cmUtil.alert("삭제할 제품을 선택해주세요");
      return false;
    }
    if (
      !(await cmUtil.confirm(
        `선택된 제품 ${ids.length}건을<br>삭제하시겠습니까?`
      ))
    ) {
      return;
    }

    const res = await cmApi.deleteUserRecentlyProdList({ ids: ids });
    const { resultCode, message } = res;
    if (resultCode !== 200) {
      return false;
    }
    cmUtil.toast(`${message}`, { type: "basket" });
    searchCmd("biz1#search");
  }
  // ◼ [전체삭제]
  else if (cmd === "deleteAll") {
    let ids = [];
    for (let i = 0; i < data.biz1.list.length; i++) {
      ids.push(data.biz1.list[i].idntyPrdctSn);
    }

    if (ids.length < 1) {
      cmUtil.alert("삭제할 제품을 없습니다.");
      return false;
    }
    if (
      !(await cmUtil.confirm(`제품 ${ids.length}건을<br>삭제하시겠습니까?`))
    ) {
      return;
    }
    const res = await cmApi.deleteUserRecentlyProdList({ ids: ids });
    const { resultCode, message } = res;
    if (resultCode !== 200) {
      return false;
    }
    cmUtil.toast(`${message}`, { type: "basket" });
    searchCmd("biz1#search");
  }
  // ◼ [선택] 상품상세팝업 오픈
  else if (cmd === "select") {
    prodInfoPopProps.value.matnr = parms.matnr;
    isShowProdInfoPop.value = true;
    // 상품선택 기능없음
  }
  // ◼ [장바구니]
  else if (cmd === "cart") {
    let parm = {
      goodsSn: parms.goodsSn,
      zzlqdCls: parms.zzlqdCls,
      goodsQty: parms.qty,
    };
    cmApi.insertUserBasketProd(parm); // 장바구니 추가
  }
  // ◼ [바로주문]
  else if (cmd === "buy") {
    const params = {
      goodsSn: parms.goodsSn,
      goodsQty: parms.qty,
      zempNo: data.selectedBranch?.kunn2,
      path: data.page.path,
    };
    await orderApi.createTempOrder(params);
  }
  // ◼ [삭제]
  else if (cmd === "delete") {
    let ids = [];
    ids.push(parms.idntyPrdctSn);

    if (ids.length < 1) {
      cmUtil.alert("삭제할 제품을 선택해주세요");
      return false;
    }
    if (!(await cmUtil.confirm(`제품을<br>삭제하시겠습니까?`))) {
      return;
    }

    const res = await cmApi.deleteUserRecentlyProdList({ ids: ids });

    const { resultCode, message } = res;
    if (resultCode !== 200) {
      return false;
    }
    cmUtil.toast(`${message}`, { type: "basket" });
    searchCmd("biz1#search");
  }
  // ◼ 기타
  else {
    alert(
      `[개발확인] recentlyViewedProd btnCmd() cmd [${cmd}] 를 확인해주세요` +
        JSON.stringify(parms, null, " ")
    );
    return false;
  }
}

// 상세팝업에서 장바구니 담기
const addCartItem = async (param = { product: null, quantity: 0 }) => {
  await cmApi.insertUserBasketProd({
    goodsSn: param.product.goodsSn,
    goodsQty: param.quantity,
    vwerk: data.page.userLoginInfo.vwerk,
    zzlqdCls: param.product.zzlqdCls,
  });
};
provide("addCartItem", addCartItem);

// 상세팝업에서 바로주문
const addBuyItem = async (product) => {
  const param = {
    goodsSn: product.goodsSn,
    goodsQty: product.quantity,
    zempNo: data.selectedBranch.kunn2,
    path: data.page.path,
  };
  await orderApi.createTempOrder(param);
};
provide("addBuyItem", addBuyItem);
</script>
<style scoped></style>
